export default __webpack_public_path__ + "static/media/braided_type.ecda6399.jpeg";